<template>
  <!-- Footer -->
  <footer class="unselectable">
    <div class="container">
      <div
        class="back-to-top"
        @click="backToTop"
      >
        {{ $t(`operate.backToTop`) }}
      </div>

      <ul class="catagory pc-only">
        <li>
          <p>分类</p>
          <ul class="item">
            <li v-for="type in keys(types)">
              <a v-link="{ name: 'search', query: { 'type': type } }">{{ types[type] }}</a>
            </li>
          </ul>
        </li>
        <li v-for="c in menu">
          <p>{{ c.title }}</p>
          <ul class="item">
            <li v-for="i in c.items">
              <a
                v-if="i.hasOwnProperty('link')"
                v-link="{ name: i.link || 'index' }"
                :class="{ disabled: !!i.disabled}"
              >{{ i.title }}</a>
              <a
                v-if="i.hasOwnProperty('href')"
                :href="i.href"
                :class="{ disabled: !!i.disabled}"
              >{{ i.title }}</a>
            </li>
          </ul>
        </li>
        <li>
          <!-- <p>UmiUni · 小程序</p> -->
          <img
            style="height:150px; width:150px;"
            src="../assets/qr-wxapp-circle.jpg"
            width="150"
          >
        </li>
      </ul>

      <!-- 	<h5 style="color:#fff">Find Us On</h5>
      <div class="w3-xlarge w3-padding-16">
        <a class="link" href="https://www.facebook.com/umiuniofficial/" target="_blank">
          <i class="fa fa-facebook-official w3-hover-text-indigo"></i>
        </a>
        <a class="link" href="https://www.instagram.com/umiuni_official/" target="_blank">
          <i class="fa fa-instagram w3-hover-text-purple"></i>
        </a>
        <i class="fa fa-snapchat w3-hover-text-yellow"></i>
        <i class="fa fa-pinterest-p w3-hover-text-red"></i>
        <i class="fa fa-twitter w3-hover-text-light-blue"></i>
      </div> -->

      <hr>

      <div class="copyright">
        <!-- <a href="http://www.miitbeian.gov.cn/">陕ICP备17004530号</a> -->&copy; alumni.umiuni.com, 2016-2040.
      </div>
    </div>
  </footer>
</template>

<script>
import { scrollPosition } from '../utils/scroll';
import storeUser from '../vuex/store';
import { getTypes } from '../vuex/getters';

export default {
  store: storeUser,
  vuex: {
    getters: {
      types: getTypes,
    },
  },

  data () {
    return {
      menu: [
        {
          title: 'UmiUni',
          items: [
            {
              title: '关于我们',
              link: 'help-about',
            }, {
              title: '联系我们',
              link: 'contact-us',
            }, {
              title: '招聘信息',
              link: 'new-hire',
            }, {
              title: '常见问题',
              link: 'help-faq',
            },
          ],
        },
        {
          title: '账号',
          items: [
            {
              title: '个人主页',
              link: 'user-nav',
            }, {
              title: '校友专属邮箱',
              link: 'help-email',
            }, {
              title: '商业合作',
              link: 'business-partnership',
            }
          ],
        // },
        // {
        //   title: '关注我们',
        //   items: [
        //     {
        //       title: '<i class="iconfont icon-weixin"></i> 微信公众平台',
        //       href: null,
        //       disabled: true,
        //     }, {
        //       title: '<i class="iconfont icon-unie61d"></i> 新浪微博',
        //       href: null,
        //       disabled: true,
        //     }, {
        //       title: '<i class="iconfont icon-facebook"></i> Facebook',
        //       href: null,
        //       disabled: true,
        //     }, {
        //       title: '<i class="iconfont icon-instagram"></i> Instagram',
        //       href: null,
        //       disabled: true,
        //     },
        //   ],
        },
      ],
    };
  },

  methods: {
    keys: Object.keys,

    backToTop () {
      scrollPosition(null);
    },
  },
};
</script>

<style scoped lang="less">
@import '../styles/iconfont/iconfont.css';
@import '../styles/const.less';

footer {
	margin-top: 80px;
	padding: 30px 0;
	background-color: #232f3e;

	position: relative;

	width: 100%;

    .container {
        width: 100%;
        max-width: 1140px;

        margin: 0 auto;
    }

	text-align: center;

	.back-to-top {
		display: block;
		position: absolute;
		top: -50px;
		left: 0;
		right: 0;

		height: 50px;
		line-height: 50px;

		background-color: #37475a;
		color: #fff;

		&:hover {
			background-color: #485769;
		}

		cursor: pointer;
	}

    ul.catagory {
        padding: 0;
        margin: 0;

        width: 100%;
        max-width: 1140px;

        margin: 30px auto;

        overflow: hidden;

        & > li {
            padding: 0 0 0 30px;
            display: inline-block;
            float: left;
            width: 20%;
            @media screen and (max-width: 769px) {
                width: 100%;
                padding: 0 20px;
            }
            text-align: left;

            p {
                font-weight: 700;
                color: #ddd;
                font-family: arial,sans-serif;
                font-size: 16px;
                margin: 6px 0 14px 0;
                white-space: nowrap;
            }

            ul.item {
                padding: 0;
                margin: 0 0 10px;
                & > li {
                    margin: 0 0 10px;
                    @media screen and (max-width: 769px) {
                        margin: 0 0 5px;
                    }
                    a {
                        color: #ddd;
                        display: inline-block;

                        &:hover {
                            background: fade(#ddd, 80%);
                            color: #000;
                        }

                        &.disabled {
                            color: #ddd !important;
                            background: none !important;
                            cursor: default;
                            opacity: 0.5;
                        }
                    }
                }
            }
        }
    }

    hr {
        border-top: 1px solid #3a4553;
        @media screen and (max-width: 769px) {
            border: none;
        }
    }

    .copyright {
        margin: 30px auto 0;

        @media screen and (max-width: 769px) {
            margin: 0 auto;
        }

		@media screen and (max-width: 769px) {
			margin-bottom: 50px;
		}

		width: 100%;
        max-width: @centent-width;
    }
}

a.link {color:#fff; background-color:transparent; text-decoration:none}
</style>



// WEBPACK FOOTER //
// Footer.vue?be95472a